import { render, staticRenderFns } from "./excel.vue?vue&type=template&id=9064d7ac&scoped=true&"
import script from "./excel.vue?vue&type=script&lang=js&"
export * from "./excel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9064d7ac",
  null
  
)

export default component.exports